import {Component, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {Pagination} from "@models/pagination.model";
import {ToastrService} from "ngx-toastr";
import {FormsService} from "@shared/api/services/v2/forms.service";
import {PatientFormResultsService} from "@shared/api/services/v2/patient-form-results.service";
import {PatientsService} from "@shared/api/services/v2/patients.service";
import {KeyValuePipe} from "@angular/common";
import {StageDTO} from "@cdss/pages/patient-registration/care-programme/module-item.dto";
import {UserCareProgram} from "@shared/api/models/query/user-care-program.model";
import {CareProgramModule} from "@shared/api/models/query/care-program.model";
import {CareProgramModulesService} from "@shared/api/services/v2/care-program-modules.service";
import {UserCareProgramsService} from "@shared/api/services/v2/user-care-programs.service";
import {UserBasic} from "@shared/api/models/query/user.model";

@Component({
    selector: 'patient-registration-confirmation-care-programme',
    imports: [
        ReactiveFormsModule,
        FormsModule,
        KeyValuePipe,
    ],
    templateUrl: './patient-registration-confirmation-care-programme.component.html',
    standalone: true,
    styleUrl: './patient-registration-confirmation-care-programme.component.scss'
})
export class PatientRegistrationConfirmationCareProgrammeComponent implements OnInit {
    loading: boolean = false

    private get limits() {
        const w = this.userCareProgram?.careProgram?.weeksConfig;
        const early = w?.early ?? 6;
        const mid = early + (w?.mid ?? 7);
        const late = mid + (w?.late ?? 7);
        return { early, mid, late };
    }
    stageItems: StageDTO = {
        early: {},
        mid: {},
        late: {}
    }
    userCareProgram: UserCareProgram
    careProgramModules: CareProgramModule[]

    constructor(
        private toastr: ToastrService,
        private formsService: FormsService,
        private patientFormResultsService: PatientFormResultsService,
        private patientsService: PatientsService,
        private careProgramModulesService: CareProgramModulesService,
        private userCareProgramsService: UserCareProgramsService
    ) {
    }

    ngOnInit(): void {

    }

    init(user: UserBasic) {
        const pagination = new Pagination()
        pagination.filter = {
            user: user.id,
        }
        this.userCareProgramsService.listPaginated(pagination).subscribe({
            next: (response) => {
                if (response.data.length > 0) {
                    this.initModules(response.data[0])
                }
            }
        })
    }

    async initModules(userCareProgram: UserCareProgram) {
        this.userCareProgram = userCareProgram
        this.careProgramModulesService.setParent(this.userCareProgram.careProgram.id)
        const response = await this.careProgramModulesService.listAllStrict()
        this.careProgramModules = response.data


        this.initStageItems()
        this.userCareProgram.specification.weeks.forEach(week => {
            week.modules.forEach(moduleId => {
                const careProgramModule = this.careProgramModules.find(careProgramModule => careProgramModule.id == moduleId)
                const module = {
                    id: moduleId,
                    title: careProgramModule?.module.displayTitlePortal ?? careProgramModule?.module.displayTitle
                }
                if (week.number <= this.limits.early) {
                    this.stageItems.early[week.number.toString().padStart(2, '0')].push(module)
                }
                if (week.number > this.limits.early && week.number <= this.limits.mid) {
                    this.stageItems.mid[week.number.toString().padStart(2, '0')].push(module)
                }
                if (week.number > this.limits.mid) {
                    this.stageItems.late[week.number.toString().padStart(2, '0')].push(module)
                }
            })
        })
    }

    initStageItems() {
        this.stageItems = {
            early: {},
            mid: {},
            late: {},
        }
        for (let i = 1; i <= this.limits.late; i++) {
            if (i <= this.limits.early) {
                this.stageItems.early[i.toString().padStart(2, '0')] = []
            }
            if (i > this.limits.early && i <= this.limits.mid) {
                this.stageItems.mid[i.toString().padStart(2, '0')] = []
            }
            if (i > this.limits.mid) {
                this.stageItems.late[i.toString().padStart(2, '0')] = []
            }
        }
    }
}
